import { render, staticRenderFns } from "./MissionPointExpirationModalSection.vue?vue&type=template&id=518bc121&scoped=true"
import script from "./MissionPointExpirationModalSection.vue?vue&type=script&lang=ts"
export * from "./MissionPointExpirationModalSection.vue?vue&type=script&lang=ts"
import style0 from "./MissionPointExpirationModalSection.vue?vue&type=style&index=0&id=518bc121&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518bc121",
  null
  
)

export default component.exports